/* HALEYRA sticky add-to-cart — vanilla, no deps. */
(function () {
  if (window.__hlStickyAtc) return;
  window.__hlStickyAtc = true;

  function init() {
    document.querySelectorAll('hl-sticky-atc').forEach(function (bar) {
      var sectionId = bar.getAttribute('data-section-id');
      var formId = bar.querySelector('.hl-sticky-atc__btn')
        ? bar.querySelector('.hl-sticky-atc__btn').getAttribute('data-target-form')
        : null;
      var realSubmit = document.querySelector(
        '#' + (formId || '') + ' .product-form__submit, #ProductSubmitButton-' + sectionId
      );
      var anchor =
        document.querySelector('#ProductInfo-' + sectionId + ' .product-form') ||
        document.querySelector('#MainProduct-' + sectionId + ' .product-form');
      var btn = bar.querySelector('.hl-sticky-atc__btn');

      // Click forwards to the real Dawn add-to-cart button (opens cart drawer).
      if (btn) {
        btn.addEventListener('click', function () {
          var target =
            document.querySelector('#' + (formId || '') + ' .product-form__submit') ||
            document.querySelector('#MainProduct-' + sectionId + ' .product-form__submit');
          if (target) {
            target.click();
          }
        });
      }

      // Show the bar only once the main add-to-cart has scrolled out of view.
      if ('IntersectionObserver' in window && anchor) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              // Only once the form has scrolled ABOVE the viewport (not while it is still below the fold).
              var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
              bar.classList.toggle('is-visible', passed);
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0 }
        );
        io.observe(anchor);
      } else {
        bar.classList.add('is-visible');
      }

      // Keep sticky price/availability in sync with variant changes.
      var priceEl = bar.querySelector('.hl-sticky-atc__price');
      document.addEventListener('change', function (ev) {
        if (!ev.target.closest || !ev.target.closest('#MainProduct-' + sectionId)) return;
        setTimeout(function () {
          var livePrice = document.querySelector(
            '#price-' + sectionId + ' .price-item--sale, #price-' + sectionId + ' .price-item--regular'
          );
          if (livePrice && priceEl) priceEl.textContent = livePrice.textContent.trim();
          if (realSubmit && btn) {
            btn.disabled = realSubmit.disabled;
            var span = realSubmit.querySelector('span');
            if (span) btn.textContent = span.textContent.trim();
          }
        }, 60);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
